import { UnitaryRight } from 'src/Services/API';

import CGCSection from './CGCSection';
import CronJobsSection from './CronJobsSection';
import HomeEditionSection from './HomeEditionSection';
import { MbapiAdminSection } from './MbapiAdminSection';
import OnCallCentersSection from './OnCallCentersSection';
import QualificationsSection from './QualificationsSection';
import RightsSection from './RightsSection';
import RoutingsSection from './RoutingsSection';
import { ADMIN_FIRST_SECTION, ADMIN_SECOND_SECTION } from './SideBar/SideBar.types';

interface SecondSectionNavigation {
  secondSection: ADMIN_SECOND_SECTION;
  necessaryUnitaryRights: UnitaryRight[];
  component?: () => JSX.Element;
}

interface FirstSectionNavigation {
  firstSection: ADMIN_FIRST_SECTION;
  secondSections: SecondSectionNavigation[];
}

type AdminNavigation = FirstSectionNavigation[];

export const adminNavigation: AdminNavigation = [
  {
    firstSection: ADMIN_FIRST_SECTION.business,
    secondSections: [
      {
        secondSection: ADMIN_SECOND_SECTION.cgc,
        necessaryUnitaryRights: [UnitaryRight.EDIT_CGC],
        component: CGCSection,
      },
      {
        secondSection: ADMIN_SECOND_SECTION.qualifications,
        necessaryUnitaryRights: [UnitaryRight.EDIT_QUALIFICATIONS],
        component: QualificationsSection,
      },
      {
        secondSection: ADMIN_SECOND_SECTION.routing,
        necessaryUnitaryRights: [UnitaryRight.EDIT_ROUTING],
        component: RoutingsSection,
      },
      {
        secondSection: ADMIN_SECOND_SECTION.onCallCenters,
        necessaryUnitaryRights: [UnitaryRight.EDIT_ON_CALL_CENTER],
        component: OnCallCentersSection,
      },
    ],
  },
  {
    firstSection: ADMIN_FIRST_SECTION.apps,
    secondSections: [
      {
        secondSection: ADMIN_SECOND_SECTION.home,
        necessaryUnitaryRights: [UnitaryRight.EDIT_HOME_EDITION],
        component: HomeEditionSection,
      },
    ],
  },
  {
    firstSection: ADMIN_FIRST_SECTION.mbapi,
    secondSections: [
      {
        secondSection: ADMIN_SECOND_SECTION.routes,
        necessaryUnitaryRights: [UnitaryRight.ADMIN_MBAPI],
        component: MbapiAdminSection,
      },
    ],
  },
  {
    firstSection: ADMIN_FIRST_SECTION.parameters,
    secondSections: [
      {
        secondSection: ADMIN_SECOND_SECTION.rights,
        necessaryUnitaryRights: [
          UnitaryRight.ADD_ADMIN,
          UnitaryRight.ADD_ADMIN_CGC,
          UnitaryRight.ADD_ADMIN_HOME_EDITION,
        ],
        component: RightsSection,
      },
      {
        secondSection: ADMIN_SECOND_SECTION.cronJobs,
        necessaryUnitaryRights: [UnitaryRight.EDIT_CRON_JOBS],
        component: CronJobsSection,
      },
    ],
  },
];
